import moment from "moment"

class TimeUtils {
  // Get system timezone
  static getCurrentTimezone() {
    return moment.tz.guess();
  }

  // Date format
  static formatToOnlyDate(date) {
    return moment(date).format("DD-MMM-YYYY");
  }

  // Date format
  static inputFieldFormat(date) {
    return moment(date).format("YYYY-MM-DD");
  }

  // 12 hour format
  static formatTo12Hour(time) {
    return moment(time).format("hh:mm A");
  }

  // 24 hour format
  static formatTo24Hour(time) {
    return moment(time).format("HH:mm");
  }

  // Get nearest day
  static getNearestDayISO(day, time) {
    const targetDay = moment().day(day);

    if (targetDay.isSameOrBefore(moment(), "day")) {
      targetDay.add(7, "days");
    }

    const [h, m] = time.split(":");

    return targetDay
      .clone()
      .hour(h)
      .minute(m)
      .second(0)
      .millisecond(0)
      .toISOString();
  }

  static fullDayRange(date) {

    const start = moment(date).startOf("day").toISOString();
    const end = moment(date).endOf("day").toISOString();

    return {
      start,
      end,
      date: moment(start).format("YYYY-MM-DD")
    };
  }

  static customRange(date, startTime, endTime) {

    const start = moment(`${date} ${startTime}`, "YYYY-MM-DD HH:mm").toISOString();
    const end = moment(`${date} ${endTime}`, "YYYY-MM-DD HH:mm").toISOString();

    return {
      start,
      end,
      date: moment(start).format("YYYY-MM-DD")
    };
  }
}

export default TimeUtils;